import React from "react";
import * as styles from "./style.mod.scss";
import Link from "components/link";
import getImagePath from "helpers/get-image-path";

const SwitcherWithImages = ({ content }) => {

  return (
    <div className={styles.switcherWithImages}>
      {content &&
        <div className={styles.productGroup}>
          <ul className={styles.productContainer}>
            {content?.map((data, i) => {
              return (
                <Link partiallyActive={true} activeClassName={styles.selected} to={`/products${data?.url}`} key={i}>
                  <div className={styles.variantBox}>
                    <div className={styles.variantImg}>
                      <img src={getImagePath(data?.productImg)} alt={data?.productImg?.alt}/>
                    </div>
                    <div className={styles.titleAndSize}>
                      <p>{data?.name}</p>
                      {data?.productSize && 
                      <p className={styles.prodSize}>{data?.productSize}</p>
                      }
                    </div>
                    
                  </div>
                </Link>
              );
            }
            )}
          </ul>
        </div>
      }
    </div>
  );
};

export default SwitcherWithImages;